var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"breadcrumb-wrap"},[_c('span',{staticStyle:{"cursor":"pointer"},on:{"click":_vm.home}},[_vm._v("首页")]),_vm._v(" "),_c('span',[_vm._v("我的位置：")]),_vm._l((_vm.tabs),function(item,index){return _c('span',[(index!==0)?[_vm._v("/")]:_vm._e(),_vm._v(_vm._s(item))],2)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }